/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addCoachPaymentMethodForAdmin,
  addCustomerPaymentMethod,
} from "../redux/Slices/leadOfferSlice";

const StripeCoachSuccess = () => {
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState(
    localStorage.getItem("checkoutSessionId") || ""
  );
  const [leadOfferDetailsId, setLeadOfferDetailsId] = useState(
    localStorage.getItem("payment_LeadOfferDetailsId") || ""
  );

  const [isCoach, setIsCoach] = useState(
    localStorage.getItem("isCoach") === "true"
  );
  const [isAdminCoach, setIsAdminCoach] = useState(
    localStorage.getItem("isAdminCoach") === "true"
  );

  const { checkoutSession, loading, error } = useSelector(
    (state) => state.leadOffer
  );

  // Update sessionId if checkoutSession changes
  useEffect(() => {
    if (checkoutSession?.id) {
      setSessionId(checkoutSession.id);
    }
  }, [checkoutSession]);

  // Process payment method when sessionId is available
  useEffect(() => {
    if (sessionId) {
      if (isCoach) {
        dispatch(addCustomerPaymentMethod({ sessionId })).then((result) => {
          if (result.error) {
            console.error("Payment method addition failed:", result.error);
          } else {
            localStorage.removeItem("checkoutSessionId");
            localStorage.setItem("isStripeConnected", true);
            localStorage.setItem("isCoach", false);
          }
        });
      } else if (isAdminCoach) {
        dispatch(
          addCoachPaymentMethodForAdmin({
            sessionId,
            coachleadofferID: leadOfferDetailsId,
          })
        ).then((result) => {
          localStorage.removeItem("checkoutSessionId");
          localStorage.removeItem("isStripeConnected");
          localStorage.removeItem("isAdminCoach");
          localStorage.setItem("isCoach", false);
        });
      }
    }
  }, [dispatch, sessionId, leadOfferDetailsId]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2>Processing your payment method...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-red-500">Error Saving Card Details</h2>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-green-600 mb-4">
          Card Details Saved Successfully!
        </h2>
        <p className="text-gray-700">
          Your card details have been securely saved for future transactions.
          <br />
          Thank you for updating your payment information.
        </p>
      </div>
    </div>
  );
};

export default StripeCoachSuccess;
